var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isPassive ? _c('span', [_c('PassiveSkill', {
    staticClass: "mb-n2",
    attrs: {
      "id": _vm.id + '0',
      "owner": "ABL",
      "characterSkillIDs": []
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "px-4 mb-0"
  }, [_c('span', [_c('span', [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('Fruit Name'),
      "v": _vm.name,
      "width": "33%"
    }
  }), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-2 d-flex justify-center flex-column"
  }, [_c('v-img', {
    attrs: {
      "width": _vm.$size(),
      "contain": "",
      "src": _vm.icon
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-center flex-column small",
    style: {
      'width': "calc(100% - ".concat(_vm.$size(), "px)"),
      'min-height': "".concat(_vm.$size(), "px")
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "pr-1"
  }, [_vm._v("・")]), _c('div', [_c('div', [_vm._v(_vm._s(_vm.txt))])])])])])], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }